import { render, staticRenderFns } from "./Montyhall.vue?vue&type=template&id=682f53aa&scoped=true&"
import script from "./Montyhall.vue?vue&type=script&lang=js&"
export * from "./Montyhall.vue?vue&type=script&lang=js&"
import style0 from "./Montyhall.vue?vue&type=style&index=0&id=682f53aa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "682f53aa",
  null
  
)

export default component.exports